import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { Footer } from "../components/core/Footer";
import { Header } from "../components/core/Header";
import AboutPage from "../pages/AboutPage";
import ContactPage from "../pages/ContactPage";
import OccupationalTherapyPage from "../pages/OccupationalTherapyPage";
import FAQsPage from "../pages/FAQsPage";
import NeurologyGeriatricsPage from "../pages/NeurologyGeriatricsPage";
import GroupTherapyPage from "../pages/GroupTherapyPage";
import PediatricsPage from "../pages/PediatricsPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import PsychiatryPage from "../pages/PsychiatryPage";
import TermsAndConditionsPage from "../pages/TermsAndConditionsPage";
import UnknownPage from "../pages/UnknownPage";
import PracticePage from "../pages/PracticePage";
import DirectionsHoursPage from "../pages/DirectionsHoursPage";
import {
  PATH_ABOUT,
  PATH_ADDITIONAL_OFFERS,
  PATH_CONTACT,
  PATH_ERGOTHERAPIE,
  PATH_FAQ as PATH_FAQS,
  PATH_NEUROLOGIE_GERIATRIE,
  PATH_PEDIATRICS,
  PATH_PRIVACY_POLICY,
  PATH_PSYCHIATRIE,
  PATH_GROUP_THERAPY,
  PATH_START,
  PATH_TERMS_AND_CONDITIONS,
  PATH_UNKNOWN,
  PATH_PRACTICE,
  PATH_DIRECTIONS_HOURS,
  PATH_NETZVERBUND_SCHWARZWALD,
} from "../utils/constants";
import StartPage from "../pages/StartPage";
import OtherOffersPage from "../pages/OtherOffersPage";
import NetzverbundSchwarzwaldPage from "../pages/NetzverbundSchwarzwaldPage";

const ContentContainer = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pb-24 md:pb-32">
    <div>
      <div className="mx-auto max-w-6xl px-5 sm:px-8 lg:px-12 pt-10 sm:pt-14 lg:pt-20">
        {children}
      </div>
    </div>
  </div>
);

export function PublicApp() {
  const location = useLocation();

  // Reset scroll position when route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <Header />
      <ContentContainer>
        <Routes>
          <Route path={PATH_START} element={<StartPage />} />
          <Route path={PATH_ERGOTHERAPIE} element={<OccupationalTherapyPage />} />
          <Route path={PATH_NEUROLOGIE_GERIATRIE} element={<NeurologyGeriatricsPage />} />
          <Route path={PATH_PSYCHIATRIE} element={<PsychiatryPage />} />
          <Route path={PATH_PEDIATRICS} element={<PediatricsPage />} />
          <Route path={PATH_ADDITIONAL_OFFERS} element={<OtherOffersPage />} />
          <Route path={PATH_NETZVERBUND_SCHWARZWALD} element={<NetzverbundSchwarzwaldPage />} />
          <Route path={PATH_GROUP_THERAPY} element={<GroupTherapyPage />} />
          <Route path={PATH_PRACTICE} element={<PracticePage />} />
          <Route path={PATH_ABOUT} element={<AboutPage />} />
          <Route path={PATH_CONTACT} element={<ContactPage />} />
          <Route path={PATH_FAQS} element={<FAQsPage />} />
          <Route path={PATH_DIRECTIONS_HOURS} element={<DirectionsHoursPage />} />
          <Route path={PATH_TERMS_AND_CONDITIONS} element={<TermsAndConditionsPage />} />
          <Route path={PATH_PRIVACY_POLICY} element={<PrivacyPolicyPage />} />
          <Route path={PATH_UNKNOWN} element={<UnknownPage />} />
        </Routes>
      </ContentContainer>
      <Footer />
    </>
  );
}
